
// --------- AMT------
const productX1Ids = [];
const productX2Ids = ["9927075102996"];
const productX3Ids = ["9871140487444"];
const productXIds = [...productX1Ids, ...productX2Ids, ...productX3Ids];

let freeProductYId = "";
 async function addFreeProduct() {
  // 1. Get current cart
  const cart = await fetch("/cart.js").then((res) => res.json());

  // 2. Check if free product is already in cart
  const alreadyExists = cart.items.some(
    (item) => item.id == freeProductYId
  );

  if (alreadyExists) {
    console.log("Free product already in cart. Skipping...");
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
    return;
  }

  // 3. Add free product
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: freeProductYId,
      quantity: 1,
    }),
  })
  .then(() => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:open", { bubbles: true }));
  })
  .catch((error) => console.error(error));
}

async function init(productId) {
  if (!productId) return;

  if (!productXIds.includes(productId)) return;

  // Map free product
  if (productX2Ids.includes(productId)) {
    freeProductYId = "51030501130516";
  }
  if (productX3Ids.includes(productId)) {
    freeProductYId = "51030501130516";
  }

  if (!freeProductYId) return;

  console.log("freeProductYId", freeProductYId);

  await addFreeProduct();
}

/* ================================
   CROSS-SELL ADD TO CART BUTTON
================================ */
document.addEventListener("click", async function (event) {
  let btn = event.target.closest(".cross-atc-btn");
  if (!btn) return;

  let productId = btn.dataset.productId;

  freeProductYId = "";

  if (!productXIds.includes(productId)) {
    freeProductYId = "";
  };
  if (productX2Ids.includes(productId)) {
    freeProductYId = "51030501130516";
  }
  if (productX3Ids.includes(productId)) {
    freeProductYId = "51030501130516";
  }

  if(freeProductYId != ""){
    const cart = await fetch("/cart.js").then((res) => res.json());
    const alreadyExists = cart.items.some(
      (item) => item.id == freeProductYId
    );
    if (!alreadyExists) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: freeProductYId,
          quantity: 1,
        }),
      });
    }
  }

  let variantId = btn.dataset.variantId;

  btn.disabled = true;
  btn.innerText = "Adding...";

  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => res.json())
    .then(() => {

      btn.innerText = "Added ✓";

      // Refresh drawer cart
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", { bubbles: true })
      );

      setTimeout(() => {
        btn.disabled = false;
        btn.innerText = "Add to Cart";
      }, 1200);
    })

    .catch(err => {
      console.error("ATC Error:", err);
      btn.disabled = false;
      btn.innerText = "Error — Try Again";
    });
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest(
    'form[action="/cart/add"] button[type="submit"], #product-sticky-form button[type="submit"]'
  );

  if (!btn) return;

  const form = btn.closest('form[action="/cart/add"], #product-sticky-form');
  if (!form) return;

  const productInput = form.querySelector('input[name="product-id"]');
  if (!productInput) return;

  const productId = productInput.value;

  console.log("Product ID: " + productId);
  init(productId);
});
// --------- AMT END------

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[href="/account/login"]').forEach((el) => {
    el.addEventListener("click", function (event) {
      changeLoginLinks();
    });
  });
  changeLoginLinks();
  function changeLoginLinks() {
    console.log("Clicked1");
    setTimeout(() => {
      console.log("Clicked2", "changeLoginLinks");
      document
        .querySelector('[href="/apps/simply-otp-login/privacy-policy"]')
        ?.setAttribute("href", "/policies/privacy-policy");

      document
        .querySelector('[href="/apps/simply-otp-login/terms-and-conditions"]')
        ?.setAttribute("href", "/policies/terms-of-service");
    }, 500);
  }
  // setTimeout(function () {
  if (window.location.pathname.includes("/collections/")) {
    const links = document.querySelectorAll(
      '#PageContainer motion-list a.media-card__link[href*="/collections/"]'
    );
    links.forEach((link) => {
      const img = link.querySelector("img");
      if (img) {
        img.remove();
      }
    });
    const sectionCollection = document.querySelector(
      "#MainContent .collection-banner-section"
    );
    if (sectionCollection) {
      const moveDivCollection =
        sectionCollection.nextElementSibling?.nextElementSibling;
      const hereCollection = document.querySelector(
        "#MainContent .collection__topbar"
      );

      if (moveDivCollection && hereCollection) {
        hereCollection.insertAdjacentElement("afterend", moveDivCollection);
        // hereCollection.prepend(moveDivCollection);
      }
    }
  }
  // }, 500); // Increased delay (3 seconds)

  var offset,
    pageYOffset,
    infixLogo,
    innerWidth = window.innerWidth;
  if (innerWidth <= 768) {
    const sectionAward = document.querySelector(
      "#shopify-section-template--24410571997460__image_with_text_tzG4dD"
    );
    if (sectionAward) {
      const buttonAward = sectionAward.querySelector("a.button");
      const paragraphAward = sectionAward.querySelector(".subtext-custom h2");
      if (buttonAward && paragraphAward) {
        paragraphAward.appendChild(buttonAward);
      }
      const textAward = sectionAward.querySelector(".subtext-md");
      const imageAward = sectionAward.querySelector(".image-with-text__media");
      if (textAward && imageAward) {
        imageAward.appendChild(textAward);
        textAward.classList.add("text-center");
      }
    }
  }

  //Start Laptop Recent View

  // var innerWidth = window.innerWidth;
  // const recentlyViewed = document.querySelector(
  //   "#shopify-section-template--24410571473172__recently-viewed"
  // );
  // const collectionContent = document.querySelector(".collection__content.flex");

  // if (recentlyViewed && collectionContent && collectionContent.parentNode) {
  //   collectionContent.parentNode.insertBefore(
  //     recentlyViewed,
  //     collectionContent.nextSibling
  //   );
  // }

  var innerWidth = window.innerWidth;

  const recentlyViewedIds = [
    "shopify-section-template--24410571473172__recently-viewed",
    "shopify-section-template--24410571571476__recently-viewed",
    "shopify-section-template--24410571669780__recently-viewed",
    "shopify-section-template--24410571637012__recently-viewed",
    "shopify-section-template--24410571407636__recently-viewed",
    "shopify-section-template--24410571702548__recently-viewed",
  ];

  const collectionContent = document.querySelector(".collection__content.flex");

  if (collectionContent && collectionContent.parentNode) {
    recentlyViewedIds.forEach(function (id) {
      const recentlyViewed = document.getElementById(id);
      if (recentlyViewed) {
        collectionContent.parentNode.insertBefore(
          recentlyViewed,
          collectionContent.nextSibling
        );
      }
    });
  }

  // End Laptop Recent View

  var buySections = document.querySelectorAll(".pdp-buy-sec");
  const topbar = document.querySelector(".topbar");
  const headers = document.querySelectorAll("header");
  window.addEventListener("scroll", function () {
    pageYOffset = window.pageYOffset;
    offset = topbar.offsetTop;

    if (innerWidth <= 768 && window.location.pathname.includes("/products/")) {
      pageYOffset -= 600;
    }
    if (pageYOffset > offset) {
      if (topbar && topbar.parentElement) {
        topbar.parentElement.classList.add("top_bar_sticky");
        topbar.parentElement.style.transition = "all 0.4s ease";
        if (window.location.pathname.includes("/xos")) {
          topbar.parentElement.style.zIndex = "0";
        }
      }

      headers.forEach((header) => {
        header.classList.add("mm-header-sticky");
        header.style.transition = "all 0.4s ease";
      });
    } else {
      if (topbar && topbar.parentElement) {
        topbar.parentElement.classList.remove("top_bar_sticky");
        topbar.parentElement.style.transition = "";
        if (window.location.pathname.includes("/xos")) {
          topbar.parentElement.style.zIndex = "";
        }
      }
      headers.forEach((header) => {
        header.classList.remove("mm-header-sticky");
        header.style.transition = "";
      });
    }
  });

  buySections.forEach(function (buySection) {
    offset = buySection.offsetTop;
    pageYOffset = 0;
    if (buySection.querySelector(".infix-logo") && innerWidth >= 768) {
      infixLogo = buySection.querySelector(".infix-logo");
    }

    if (buySection.querySelector(".infix-logo1") && innerWidth <= 768) {
      infixLogo = buySection.querySelector(".infix-logo1");
    }

    window.addEventListener("scroll", function () {
      pageYOffset = window.pageYOffset;

      if (innerWidth <= 768) {
        pageYOffset -= 600;
      }
      if (pageYOffset > offset) {
        buySection.style.position = "fixed";
        buySection.style.top = innerWidth <= 768 ? "100px" : "108px";
        buySection.style.left = "0px";
        buySection.style.width = "100%";
        buySection.style.opacity = "0.8";
        buySection.style.zIndex = "15";
        buySection.style.backgroundColor = "#000";
        buySection.style.color = "#fff";
        buySection.style.transition = "all 0.4s ease";
        if (infixLogo) {
          infixLogo.style.display = "block";
        }
        // buySection.classList.add("x-showing");
      } else {
        buySection.style.position = "absolute";
        buySection.style.top = offset + "px";
        buySection.style.backgroundColor = "";
        buySection.style.color = "";
        buySection.style.opacity = "";
        buySection.style.transition = "";
        // buySection.classList.remove("x-showing");
        if (infixLogo) {
          infixLogo.style.display = "none";
        }
      }
    });
  });

  document
    .querySelector(".cart-drawer-button")
    .addEventListener("click", () => {
      const minusButtons = document.querySelectorAll(
        '.quantity__button[name="minus"]'
      );

      minusButtons.forEach((button) => {
        // Check if SVG already exists inside the button
        if (!button.querySelector("svg.icon-decrease")) {
          const svg = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg"
          );
          svg.setAttribute("class", "icon icon-decrease icon-sm stroke-1");
          svg.setAttribute("viewBox", "0 0 8 6");
          svg.setAttribute("stroke", "currentColor");
          svg.setAttribute("fill", "none");
          svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

          const line = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line"
          );
          line.setAttribute("x1", "1");
          line.setAttribute("y1", "3");
          line.setAttribute("x2", "7");
          line.setAttribute("y2", "3");
          line.setAttribute("stroke-linecap", "round");
          line.setAttribute("stroke-linejoin", "round");

          svg.appendChild(line);
          button.appendChild(svg);
        }
      });

      const plusButtons = document.querySelectorAll(
        '.quantity__button[name="plus"]'
      );

      plusButtons.forEach((button) => {
        // Prevent duplicate SVGs
        if (!button.querySelector("svg.icon-increase")) {
          const svg = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg"
          );
          svg.setAttribute("class", "icon icon-increase icon-sm stroke-1");
          svg.setAttribute("viewBox", "0 0 8 8");
          svg.setAttribute("stroke", "currentColor");
          svg.setAttribute("fill", "none");
          svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

          const line1 = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line"
          );
          line1.setAttribute("x1", "4");
          line1.setAttribute("y1", "1");
          line1.setAttribute("x2", "4");
          line1.setAttribute("y2", "7");
          line1.setAttribute("stroke-linecap", "round");
          line1.setAttribute("stroke-linejoin", "round");

          const line2 = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "line"
          );
          line2.setAttribute("x1", "1");
          line2.setAttribute("y1", "4");
          line2.setAttribute("x2", "7");
          line2.setAttribute("y2", "4");
          line2.setAttribute("stroke-linecap", "round");
          line2.setAttribute("stroke-linejoin", "round");

          svg.appendChild(line1);
          svg.appendChild(line2);
          button.appendChild(svg);
        }
      });
    });
});

document.addEventListener("DOMContentLoaded", function () {
  //  document.addEventListener("click", function (event) {
  //   const shareBtn = event.target.closest('.mm-share');
  //   if (shareBtn) {
  //     const shareBox = shareBtn.nextElementSibling;
  //     if (shareBox && shareBox.classList.contains('sharing-tabs')) {
  //       shareBox.classList.toggle('hidden');
  //     }
  //   }
  // });

  if (window.innerWidth <= 768) {
    const paragraphs = document.querySelectorAll(".footer__newsletter > p");
    const form = document.querySelector(".footer__newsletter > form");
    const footer = document.querySelector(
      ".shopify-section-group-footer-group footer .footer__left"
    );
    const customSection = document.createElement("div");
    customSection.className = "footer__newsletter grid gap-6";
    customSection.prepend(form);
    Array.from(paragraphs)
      .reverse()
      .forEach((p) => {
        customSection.prepend(p);
      });

    if (footer) {
      footer.prepend(customSection);
    }
  }
});

var scrollTopVariant = 0;
window.addEventListener("scroll", function () {
  scrollTopVariant = window.scrollY || document.documentElement.scrollTop;
});

document.body.addEventListener("click", function (e) {
  let swatchLi = e.target.closest(".swatches li");
  if (swatchLi) {
    setTimeout(function () {
      checkAvailableOption();
    }, 1000);

    if (innerWidth <= 768) {
      let $inputs = {
        top: scrollTopVariant,
        behavior: "smooth",
      };
      setTimeout(function () {
        window.scrollTo($inputs);
      }, 1000);
    }
    // setTimeout(function () {
    //   checkAvailableOption();
    // }, 1000);
  }
});

function checkAvailableOption() {
  document
    .querySelectorAll("variant-selects fieldset")
    .forEach(function (fieldset) {
      const checkedInput = fieldset.querySelector(
        "input[type='radio']:checked"
      );

      if (checkedInput && checkedInput.classList.contains("disabled")) {
        // Find the first non-disabled radio input in the fieldset
        const alternativeInput = Array.from(
          fieldset.querySelectorAll("input[type='radio']")
        ).find((input) => !input.classList.contains("disabled"));

        if (alternativeInput) {
          checkedInput.checked = false;
          alternativeInput.click();
        }
      }
    });
}
document.addEventListener("DOMContentLoaded", function () {
  const modalOpenButtons = document.querySelectorAll(".mm-modal-open");

  modalOpenButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      const targetModal = button.getAttribute("data-target-modal");
      const modalBox = document.querySelector(
        `.mm-modal-box[data-modal='${targetModal}']`
      );
      const modalOverlay = modalBox ? modalBox.previousElementSibling : null;

      if (modalBox && modalOverlay) {
        modalOverlay.classList.add("active");
        modalBox.classList.add("active");

        const modalClose = modalBox.querySelector(".mm-modal-close");
        modalClose.addEventListener("click", function () {
          modalOverlay.classList.remove("active");
          modalBox.classList.remove("active");
        });

        modalOverlay.addEventListener("click", function () {
          modalOverlay.classList.remove("active");
          modalBox.classList.remove("active");
        });
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  function updateVisibility() {
    document
      .querySelectorAll(".desktop-next-div-show")
      .forEach((desktopDiv) => {
        const parentDiv = desktopDiv.parentElement;
        const nextDiv = parentDiv.nextElementSibling;
        if (nextDiv) {
          nextDiv.style.display = window.innerWidth > 768 ? "block" : "none";
        }
      });

    document.querySelectorAll(".mobile-next-div-show").forEach((mobileDiv) => {
      const parentDiv = mobileDiv.parentElement;
      const nextDiv = parentDiv.nextElementSibling;
      if (nextDiv) {
        nextDiv.style.display = window.innerWidth <= 768 ? "block" : "none";
      }
    });
  }

  updateVisibility(); // Run on page load
  window.addEventListener("resize", updateVisibility); // Update on resize
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("button[data-href]").forEach((button) => {
    button.addEventListener("click", function () {
      const targetId = this.getAttribute("data-href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    });
  });
});

document.querySelectorAll(".color-wrapper").forEach((wrapper) => {
  wrapper.addEventListener("click", function () {
    document
      .querySelectorAll(".color-wrapper .color")
      .forEach((el) => el.classList.remove("color-selected"));
    document.getElementById("product-image").src = this.dataset.img;
    document.getElementById("product-mobile-image").src = this.dataset.mobile;
    this.querySelector(".color").classList.add("color-selected");
  });
});

// document.addEventListener("DOMContentLoaded", () => {
//   const buySection = document.querySelector(".specs-bx");
//   if (!buySection) return;

//   const links = buySection.querySelectorAll("a, h3");
//   links.forEach((link) => (link.style.color = "#333"));

//   window.addEventListener("scroll", () => {
//     const color = window.scrollY > 50 ? "#fff" : "#333";
//     links.forEach((link) => (link.style.color = color));
//   });
// });

// animation

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[is="animate-picture"]').forEach((element) => {
    element.removeAttribute("is");
    element.removeAttribute("data-animate");
    element.style.animation = "none";
    element.style.transform = "none";
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quantity__button").forEach((button) => {
    button.innerHTML = "";
  });
});

// PDP accoding

document.addEventListener("DOMContentLoaded", function () {
  var accordions = document.querySelectorAll(".accordion-btn");

  accordions.forEach(function (btn) {
    btn.addEventListener("click", function () {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    });
  });
});

// ===== review link pdp ====

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash) {
    let element = document.querySelector(window.location.hash);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
});

// zero flip swiper

var swiper = new Swiper(".zero-flip", {
  slidesPerView: 1.5,
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true /* Dots become bigger when selected */,
  },
  on: {
    init: function () {
      document.querySelector(".swiper-button-next").style.display = "flex";
      document.querySelector(".swiper-button-prev").style.display = "flex";
      document.querySelector(".swiper-pagination").style.display =
        "block"; /* Ensure pagination is visible */
    },
  },
});

var swiper = new Swiper(".zero-min", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true /* Dots become bigger when selected */,
  },
  on: {
    init: function () {
      document.querySelector(".swiper-button-next").style.display = "flex";
      document.querySelector(".swiper-button-prev").style.display = "flex";
      document.querySelector(".swiper-pagination").style.display =
        "block"; /* Ensure pagination is visible */
    },
  },
});

function toggleDropdown() {
  document.querySelector(".dropdown-menu").classList.toggle("show");
}

// video swiper
// function playVideo(element) {
//   let parent = element.closest(".video-card");
//   let thumbnail = parent.querySelector(".thumbnail");
//   let video = parent.querySelector("lite-youtube");

//   thumbnail.style.display = "none";
//   video.style.display = "block";
//   video.playVideo();
// }

// function playVideo(element) {
//   let parent = element.closest(".video-card");
//   let thumbnail = parent.querySelector(".thumbnail");
//   let video = parent.querySelector("lite-youtube");

//   if (thumbnail && video) {
//     // Hide the thumbnailpro
//     thumbnail.style.display = "none";

//     // Show the lite-youtube component
//     video.style.display = "block";

//     // Trigger autoplay by simulating user interaction
//     video.click();
//   }
// }

// FAQ

// GT PRO  SECTION

$(document).ready(function () {
  $(".mo").click(function () {
    //$(".main").hide();
    $(".two").show();
    $(".one").hide();
    $(".three").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".ms").click(function () {
    $(".three").show();
    $(".one").hide();
    $(".two").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".mh").click(function () {
    $(".three").hide();
    $(".one").show();
    $(".two").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".one1").click(function () {
    $(".sec3").show();
    $(".sec5").hide();
    $(".sec6").hide();
    $(".sec7").hide();
    $(".image-tab li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".two1").click(function () {
    $(".sec3").hide();
    $(".sec6").hide();
    $(".sec7").hide();
    $(".sec5").show();
    $(".image-tab li").removeClass("active");

    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".three1").click(function () {
    $(".sec3").hide();
    $(".sec5").hide();
    $(".sec7").hide();
    $(".sec6").show();
    $(".image-tab li").removeClass("active");

    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".four1").click(function () {
    $(".sec3").hide();
    $(".sec5").hide();
    $(".sec6").hide();
    $(".sec7").show();
    $(".image-tab li").removeClass("active");

    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".mo").click(function () {
    //$(".main").hide();
    $(".two").show();
    $(".one").hide();
    $(".three").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".ms").click(function () {
    $(".three").show();
    $(".one").hide();
    $(".two").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});

$(document).ready(function () {
  $(".mh").click(function () {
    $(".three").hide();
    $(".one").show();
    $(".two").hide();
    $(".bg li").removeClass("active");
    $(this).addClass("active");
  });
});
// $(document).ready(function () {
//   //Hide all Tabs on laod
//   $(".Tabs").tabs();
// });

// $("#tabs1 ul li a").click(function () {
//   $(this).prev().find("li.Active").removeClass("Active");
//   $(this).find("li").addClass("Active");
// });

// ===== Youtube css ====

// ----------- xos ----

var swiper = new Swiper(".folax-swiper", {
  slidesPerView: 3.2,
  spaceBetween: 10,
  loop: false,
  autoplay: false, // Autoplay disabled
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
  on: {
    init: function () {
      document.querySelector(".swiper-button-next").style.display = "flex";
      document.querySelector(".swiper-button-prev").style.display = "flex";
      document.querySelector(".swiper-pagination").style.display =
        "block"; /* Ensure pagination is visible */
    },
  },
});

const items = document.querySelectorAll(".ai-call-item");
const imgTag = document.getElementById("ai-call-imgtag");
const videoTag = document.getElementById("ai-call-videotag");

items.forEach((item) => {
  item.addEventListener("click", () => {
    // Remove previous active class
    items.forEach((i) => i.classList.remove("ai-call-active"));
    item.classList.add("ai-call-active");

    const type = item.getAttribute("data-type");
    const src = item.getAttribute("data-src");

    if (type === "image") {
      imgTag.src = src;
      imgTag.style.display = "block";
      videoTag.style.display = "none";
      videoTag.pause();
    } else if (type === "video") {
      videoTag.querySelector("source").src = src;
      videoTag.load();
      videoTag.style.display = "block";
      imgTag.style.display = "none";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const revealEls = document.querySelectorAll(".ai-feature-reveal");
  function revealOnScroll() {
    for (let el of revealEls) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight - 70) {
        el.classList.add("revealed");
      }
    }
  }
  window.addEventListener("scroll", revealOnScroll);
  revealOnScroll();
});

const compareSlider = document.querySelector(".compare-slider");
const beforeVid = document.querySelector(".compare-vid-before");
const afterVid = document.querySelector(".compare-vid-after");
const handle = document.getElementById("compareHandle");
const divider = document.getElementById("compareDivider");
let dragging = false;
function setSlider(percent) {
  percent = Math.max(0, Math.min(100, percent));
  if(beforeVid){
    beforeVid.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
  }
  if(afterVid){
    afterVid.style.clipPath = `inset(0 0 0 ${percent}%)`;
  }
  if(handle){
    handle.style.left = percent + "%";
    handle.style.top = "50%";
  }
  if(divider){
    divider.style.left = percent + "%";
  }
}
function pointerMove(e) {
  const rect = compareSlider.getBoundingClientRect();
  let x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
  let percent = (x / rect.width) * 100;
  setSlider(percent);
}
if(handle){
  handle.addEventListener("mousedown", (e) => {
    dragging = true;
  });
  handle.addEventListener("touchstart", (e) => {
    dragging = true;
  });
}

window.addEventListener("mouseup", () => {
  dragging = false;
});
window.addEventListener("mousemove", (e) => {
  if (dragging) pointerMove(e);
});

window.addEventListener("touchend", () => {
  dragging = false;
});
window.addEventListener("touchmove", (e) => {
  if (dragging) pointerMove(e);
});
// Click to jump
if(compareSlider){
  compareSlider.addEventListener("click", (e) => pointerMove(e));
}

// Initial
setSlider(50);

new Swiper(".phoneWallpaperSwiper", {
  loop: true,
  effect: "slide",
  pagination: { el: ".swiper-pagination", clickable: true },
  allowTouchMove: true,
});

document.querySelectorAll(".aica-item").forEach((item) => {
  item.addEventListener("click", () => {
    document
      .querySelectorAll(".aica-item")
      .forEach((el) => el.classList.remove("aica-active"));
    item.classList.add("aica-active");
    const src = item.getAttribute("data-img");
    document.getElementById("aica-display").src = src;
  });
});

// Click scroll
document
  .querySelectorAll(".aica-nav-item")
  .forEach(
    (btn) =>
      (btn.onclick = () =>
        document
          .querySelector(btn.dataset.target)
          ?.scrollIntoView({ behavior: "smooth" }))
  );

// Scroll highlight
const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        document
          .querySelectorAll(".aica-pagination")
          .forEach((p) => p.classList.remove("aica-active"));
        document
          .querySelector(`.aica-nav-item[data-target="#${entry.target.id}"]`)
          ?.closest(".aica-pagination")
          ?.classList.add("aica-active");
      }
    });
  },
  { threshold: 0.6 }
);

document
  .querySelectorAll("section[id]")
  .forEach((sec) => observer.observe(sec));

// mobile swiper Xos
  new Swiper('.folax-swiper', {
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: '.folax-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      768: { slidesPerView: 1 },
      1024: { slidesPerView: 1 }
    }
  });



  var swiper = new Swiper(".aiswiper", {
  slidesPerView: 3.2,
  spaceBetween: 10,
  loop: false,
  autoplay: false, // Autoplay disabled
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    dynamicBullets: true,
  },
  breakpoints: {
    320: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
  },
 
});

  document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll('.ai-call-feature-mobile .feature-item');
    const video = document.getElementById('featureVideo');
    const baseURL = "https://d3o31au25zfcly.cloudfront.net/newfileadmin/usp/xos15/sec3/mb/";

    if (!items.length || !video) return;

    items.forEach(item => {
      item.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        // Close all
        items.forEach(el => el.classList.remove('active'));

        if (!isActive) {
          // Open clicked one
          item.classList.add('active');

          // Change video
          const newSrc = item.getAttribute('data-video');
          const source = video.querySelector('source');
          if (source && newSrc) {
            source.src = baseURL + newSrc;
            video.load();
            video.play();
          }
        }
      });
    });
  });

  new Swiper(".vogue-portrait-in-phone-swiper", {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });



  // ------- URL REDIRECT ------
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".pdp-tab");
  const HEADER_OFFSET = 180;

  const isVisible = (el) => {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    return style.display !== "none" && style.visibility !== "hidden" && el.getClientRects().length > 0;
  };

  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const targetKey = this.getAttribute("data-target");

      // 1) try data-section
      const candidates = document.querySelectorAll(`[data-section="${targetKey}"]`);

      // 2) fallback to id (if you used id="specifications" etc)
      let targetEl =
        Array.from(candidates).find(isVisible) ||
        Array.from(candidates)[0] ||
        document.getElementById(targetKey);

      // 3) if id has duplicates (bad), still pick visible one
      if (!targetEl) {
        const idCandidates = document.querySelectorAll(`#${CSS.escape(targetKey)}`);
        targetEl = Array.from(idCandidates).find(isVisible) || idCandidates[0];
      }

      if (!targetEl) return;

      const top = targetEl.getBoundingClientRect().top + window.pageYOffset - HEADER_OFFSET;

      window.scrollTo({ top, behavior: "smooth" });

      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
    });
  });
});



// ------ add  to cart -------



// ---------- sticy tax includes ------------

(function () {
  function testStickyJS() {
    const priceEl = document.querySelector(
      '.product-sticky-form__card .price__regular'
    );

    if (!priceEl) return;

    // Prevent duplicate
    if (priceEl.nextElementSibling?.classList.contains('js-test-text')) return;

    const span = document.createElement('span');
    span.className = 'js-test-text';
    span.style.color = '#B8B8B8';
    span.style.fontSize = '12px';
    span.style.marginLeft = '6px';
    span.innerText = 'MRP (Inclusive of all taxes)';

    priceEl.after(span);
  }

  testStickyJS();

  // Shopify injects sticky bar late → observer needed
  const observer = new MutationObserver(testStickyJS);
  observer.observe(document.body, { childList: true, subtree: true });
})();



// ----- PDP Load more btn --------

(function () {
  function resetShowMore() {
    // remove old button
    document.querySelectorAll(".show-more__action").forEach((el) => el.remove());

    // unhide blocks hidden by show more
    document.querySelectorAll("[data-hidden-by-show-more='1']").forEach((block) => {
      block.style.display = block.dataset.origDisplay || "";
      block.removeAttribute("data-hidden-by-show-more");
    });

    // unhide items hidden by show more
    document.querySelectorAll("[data-showmore-hidden='1']").forEach((item) => {
      item.style.display = item.dataset.origDisplay || "";
      item.removeAttribute("data-showmore-hidden");
    });
  }

  function initZeroFlipSwiper() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (!isMobile) return;

    document
      .querySelectorAll(".swiper-container.zero-flip, .swiper.zero-flip")
      .forEach((container) => {
        if (container.swiper) return;

        const nextEl = container.querySelector(".swiper-button-next");
        const prevEl = container.querySelector(".swiper-button-prev");
        const pagEl = container.querySelector(".swiper-pagination");

        new Swiper(container, {
          loop: true,
          spaceBetween: 10,
          slidesPerView: 1,
          autoplay: false,
          breakpoints: {
            360: { slidesPerView: 2.2 },
          },
          pagination: pagEl ? { el: pagEl, clickable: true } : undefined,
          navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
        });
      });
  }

  // ✅ NEW: wrap each swiper in-place (NO merging)
  function wrapIntoMobileShow(el) {
    if (!el) return;

    // already wrapped / already inside .mobile-show
    if (el.closest(".pdp-media-wrap") || el.closest(".mobile-show")) return;

    const wrap = document.createElement("section");
    wrap.className = "mobile-show pdp-mobile pdp-media-wrap";

    // insert wrapper exactly where element currently is
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
  }

  function initShowMoreMedia() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    resetShowMore();

    // ✅ IMPORTANT FIX: do NOT collect all into one wrapper
    if (isMobile) {
      const targets = document.querySelectorAll(
        ".note-fts-fg, .swiper-container.zero-flip, .swiper.zero-flip"
      );
      targets.forEach(wrapIntoMobileShow);
    }

    // init swiper after wrapping
    initZeroFlipSwiper();

    const sections = isMobile
      ? document.querySelectorAll(".mobile-show.pdp-mobile, .mobile-show")
      : document.querySelectorAll("#overview-desktop");

    if (!sections.length) return;

    const IMAGE_LIMIT = 2;
    let imageCount = 0;

    const hiddenItems = [];
    const hiddenBlocks = [];

    sections.forEach((section) => {
      const media = section.querySelectorAll("img, video");

      media.forEach((item) => {
        if (item.tagName === "IMG") imageCount++;

        if (imageCount > IMAGE_LIMIT) {
          const swiperBlock = item.closest(
            ".note-fts-fg, .swiper-container.zero-flip, .swiper.zero-flip, .zero-flip"
          );

          // hide whole swiper block (mobile)
          if (isMobile && swiperBlock && !swiperBlock.dataset.hiddenByShowMore) {
            swiperBlock.dataset.hiddenByShowMore = "1";
            swiperBlock.dataset.origDisplay = swiperBlock.style.display || "";
            swiperBlock.style.display = "none";
            swiperBlock.querySelectorAll("video").forEach((v) => v.pause());
            hiddenBlocks.push(swiperBlock);
            return;
          }

          // hide normal item
          if (!item.dataset.origDisplay) item.dataset.origDisplay = item.style.display || "";
          item.style.display = "none";
          item.dataset.showmoreHidden = "1";

          if (item.tagName === "VIDEO") item.pause();
          hiddenItems.push(item);
        }
      });
    });

    if (!hiddenItems.length && !hiddenBlocks.length) return;

    // button
    const actionWrap = document.createElement("div");
    actionWrap.className = "show-more__action gradient";

    const btn = document.createElement("button");
    btn.className = "overview-load-more";
    btn.type = "button";
    btn.innerText = "Show More";
    btn.style.padding = "12px 70px";
    btn.style.border = "1px solid #000";
    btn.style.background = "#fff";
    btn.style.cursor = "pointer";

    actionWrap.appendChild(btn);
    sections[sections.length - 1].after(actionWrap);

    btn.addEventListener("click", function () {
      hiddenBlocks.forEach((block) => {
        block.style.display = block.dataset.origDisplay || "";

        requestAnimationFrame(() => {
          if (block.swiper) block.swiper.update();
          block.querySelectorAll(".swiper, .swiper-container").forEach((swEl) => {
            if (swEl.swiper) swEl.swiper.update();
          });
        });
      });

      hiddenItems.forEach((item) => {
        item.style.display = item.dataset.origDisplay || "";
        item.removeAttribute("data-showmore-hidden");
        if (item.tagName === "VIDEO") item.play();
      });

      actionWrap.remove();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShowMoreMedia);
  } else {
    initShowMoreMedia();
  }

  document.addEventListener("shopify:section:load", initShowMoreMedia);
})();


// --------------- logion OTP Onload pe show  -----------------

